"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMeasureFromRankingFilterJaql = exports.createMeasureFromFilterJaql = exports.createAttributeFromFilterJaql = void 0;
const utils_js_1 = require("../../../utils.js");
/**
 * Creates an attribute or level attribute from the provided filter JAQL object
 *
 * @param jaql - Filter JAQL object
 * @returns attribute or level attribute
 */
const createAttributeFromFilterJaql = (jaql) => {
    const { dim, table, column, level, datatype, title, datasource: dataSource } = jaql;
    return (0, utils_js_1.createAttributeHelper)({
        dim,
        table,
        column,
        dataType: datatype,
        level,
        format: undefined,
        sort: undefined,
        title,
        dataSource,
    });
};
exports.createAttributeFromFilterJaql = createAttributeFromFilterJaql;
/**
 * Creates a measure from the provided filter JAQL object
 *
 * @param jaql - Filter JAQL object
 * @returns Measure
 */
const createMeasureFromFilterJaql = (jaql) => {
    const { dim, table, column, title, level, datatype: dataType, agg, datasource: dataSource, } = jaql;
    if (!agg)
        return undefined;
    return (0, utils_js_1.createMeasureHelper)({
        dim,
        table,
        column,
        dataType,
        agg,
        level,
        format: undefined,
        sort: undefined,
        title,
        dataSource,
    });
};
exports.createMeasureFromFilterJaql = createMeasureFromFilterJaql;
/**
 * Creates a measure from the provided ranking filter JAQL object
 *
 * @param jaql - Ranking filter Jaql object
 * @returns Measure
 */
const createMeasureFromRankingFilterJaql = (jaql, rankingMessage) => {
    if ('formula' in jaql)
        return (0, utils_js_1.createCalculatedMeasureHelper)(jaql);
    const { dim, table, column, level, datatype: dataType, agg } = jaql;
    return (0, utils_js_1.createMeasureHelper)({
        dim,
        table,
        column,
        level,
        dataType,
        agg,
        format: undefined,
        sort: undefined,
        title: rankingMessage,
    });
};
exports.createMeasureFromRankingFilterJaql = createMeasureFromRankingFilterJaql;
